import { setScatter, formatRegions, setGeo, setLines, toScatter } from "../tools";

import * as echarts from 'echarts';

export default {
  name: 'CeMap',
  props: {
    id: { type: String, default: () => (`a-map-${Math.random().toString().substring(2)}`) },
    resizeCondition: { type: Array, default: () => ['width'] },
    theme: { type: String, default: () => 'macarons' },
    delay: { type: Number, default: () => 800 },
    area: { type: String, default: () => '' },
    site: { type: String, default: () => '' },
    data: { type: Array, default: () => [] },
    width: { type: String, default: () => '100%' },
    height: { type: String, default: () => '100%' },
    config: { type: Object, default: () => ({}) },
    adCode: { type: String, default: () => '430100' },
    background: { type: String, default: () => '#07a1fe' },
    acticeBackground: { type: String, default: () => 'red' },
    enableScale: { type: Boolean, default: () => true },
    delay: { type: Number, default: () => 1000 },
  },
  data() {
    return {
      charts: null,
      option: null,
      regions: null,
      zoom: 1.2,
    }
  },
  watch: {
    area: {
      deep: true,
      handler() {
        this.create();
      }
    },
    $route() {
      this.create();
    }
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      if (this.area != '') {
        this.cancel();
        const area = JSON.parse(this.area);
        if (area) echarts.registerMap(this.id, area);
        this.regions = formatRegions(area, this.background);
        const theme = require(`echarts/theme/${this.theme}`);
        let charts = echarts.getInstanceByDom(this.$el);
        if (charts) echarts.dispose(charts);
        this.charts = echarts.init(this.$el, theme && theme != '' ? this.theme : '');
        this.charts.clear();
        const effectScatterConfig = { // 站点动画图标公用配置
          type: 'effectScatter',
          symbol: 'circle',
          symbolSize: 4,
          rippleEffect: { // 设置涟漪动画样式
            period: 6,  // 动画周期
            scale: 12,  // 涟漪规模
            brushType: 'fill'
          },
          zlevel: 1000,
          coordinateSystem: 'geo',
        }
        this.option = {
          geo: setGeo(this.id, this.regions),
          series: [
            {
              ...effectScatterConfig,
              rippleEffect: { // 设置涟漪动画样式
                period: 4,  // 动画周期
                scale: 16,  // 涟漪规模
                brushType: 'fill'
              },
              data: [{
                ...this.regions[0],
                name: this.regions[0].name,
                value: [...this.regions[0].center, this.regions[0].value],
                itemStyle: {
                  normal: { color: 'orange' }, // 主站点颜色
                },
              }]
            },
            {
              ...effectScatterConfig,
              data: this.regions.map((a, b) => {
                if (b != 0) return {
                  ...a,
                  name: a.name,
                  value: [...a.center, a.value],
                  itemStyle: {
                    normal: { color: '#1ed76d' }, // 次站点颜色
                  },
                }
              })
            },
            ...setLines(this.regions, this.adCode),
          ],
          ...this.config,
        };
        this.charts.setOption(this.option);
        let timeout = null;
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        } else {
          timeout = setTimeout(() => {
            addEventListener('resize', () => this.charts && this.charts.resize());
            addEventListener('transitionend', a => this.charts && this.resize(a));
            clearTimeout(timeout);
            timeout = null;
          }, this.delay);
        }
        if (this.regions && this.regions.length > 0) {
          this.charts.off('click');
          this.charts.on('click', region => {
            let area = region.region || region.data || null;
            this.regions.forEach(a => {
              a.selected = false;
              if (area && (a.id == area.id)) a.selected = !area.selected;
            });
            this.select(area);
          });
          this.charts.off('georoam');
          this.charts.on('georoam', ({ zoom }) => zoom && (this.zoom = Number((this.zoom * zoom.toFixed(1)).toFixed(1))));
          (this.option && this.option.geo && this.option.geo.zoom) ? this.option.geo.zoom = this.zoom : () => null;
        }
      }
    },
    resize({ propertyName }) {
      this.resizeCondition.includes(propertyName) && this.charts.resize();
    },
    select(a) {
      this.$emit('select', a && !a.selected && a);
    },
    cancel() {
      if (this.charts) {
        removeEventListener('transitionend', this.charts.resize);
        removeEventListener('resize', this.resize);
        this.$nextTick(() => {
          this.charts.dispose();
          this.option = null;
          this.charts = null;
        });
      }
    },
  },
  render() {
    return <div id={this.id} key={this.id} class="c-e-map" style={{ width: this.width, height: this.height }} />
  }
}